
  export default {
    name: "cal-swipe-product-list",
    props: ["productList"],
    data() {
      return {
        visibleItems: 0
      }
    },
    computed: {
      isMobile() {
        return window.matchMedia("(max-width: 768px)").matches;
      },
    },
    methods: {
      sendToDataLayer() {
        window.dataLayer?.push({event: "click_other_available"});
      },
    },
  }
